import React from "react";
import LinkTo from "helpers/LinkTo";
import {useTranslation} from "react-i18next";

interface FooterSidebarRightProps {
}

const FooterSidebarRight = (props: FooterSidebarRightProps) => {
    const {t} = useTranslation();

    return (
        <div className={"FooterSidebarRight w-auto flex flex-col gap-y-4 md:gap-y-6 text-left"}>
            <h2 className={"font-zuume font-bold text-[32px]"}>{t("Menu")}</h2>
            <div>
                <ul className={"font-semibold"}>
                    <li>
                        <a className={"hover:text-arbo-red"} href={"https://www.arbopark.ch"}>{t("Homepage")}</a>
                    </li>
                    <li>
                        <a className={"hover:text-arbo-red"} href={LinkTo.terms()}>{t("Terms and conditions")}</a>
                    </li>
                    <li>
                        <a className={"hover:text-arbo-red"} href={LinkTo.impressum()}>{t("Impressum")}</a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default FooterSidebarRight;